import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orDash',
    standalone: true
})
export class OrDashPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: any): string {
        return (value === undefined || value === null || (typeof value === 'string' && value.trim() === ''))
            ? '\u2014'
            : String(value);
    }
}
